import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'echexpayment-thank-you-bank-auth',
  templateUrl: './thank-you-link.component.html',
  //styleUrls: ['./thank-you.component.css']
})
export class ThankYouLinkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/generate-bankauth-url/thank-you-link.component.ts